// Define the initial state for the reducer
const initialState = {
    shopfloor_filter_object: {
        DimensionKey: {
            period: null,
            product: null,
            location: null,
        },
        DimensionValues: {
            product: null,
            location: null,
            period: null,
        },
        slec: null,
    },
    process: null,
};

const UPDATE_SHOPFLOOR_DATA = (state = initialState, action) =>{
    switch(action.type){
        case 'UPDATE_PROCESS' : 
            return {...state , process : action.payload }
            case 'SET_SHOPFLOOR_SELECTION_ID' : 
            return {   
                ...state,
                shopfloor_filter_object: {
                    ...state.shopfloor_filter_object,
                    slec:action.payload
                }
            };  
            case 'SET_SHOPFLOOR_PERIOD_BUCKET' : 
            return {   
                ...state,
                shopfloor_filter_object: {
                    ...state.shopfloor_filter_object,
                    DimensionKey: {
                        ...state.shopfloor_filter_object.DimensionKey,
                        period: action.payload,
                    }
                }
            };                            
        case 'SET_SHOPFLOOR_PRODUCT_LAVAL' : 
        return {   
            ...state,
            shopfloor_filter_object: {
                ...state.shopfloor_filter_object,
                DimensionKey: {
                    ...state.shopfloor_filter_object.DimensionKey,
                    product: action.payload,
                }
            }
        };  
        case 'SET_SHOPFLOOR_LOCATION_LAVAL' : 
                return {   
                    ...state,
                    shopfloor_filter_object: {
                        ...state.shopfloor_filter_object,
                        DimensionKey: {
                            ...state.shopfloor_filter_object.DimensionKey,
                            location: action.payload,
                        }
                    }
                };        
        case 'UPDATE_SHOPFLOOR_FILTER_OBJECT' : 
            return {...state , shopfloor_filter_object : action.payload}
        case 'SET_SHOPFLOOR_PRODUCTS':
                return {   
                    ...state,
                    shopfloor_filter_object: {
                        ...state.shopfloor_filter_object,
                        DimensionValues: {
                            ...state.shopfloor_filter_object.DimensionValues,
                            product: action.payload,
                        }
                    }
                };    
                case 'SET_SHOPFLOOR_LOCATIONS':
                    return {   
                        ...state,
                        shopfloor_filter_object: {
                            ...state.shopfloor_filter_object,
                            DimensionValues: {
                                ...state.shopfloor_filter_object.DimensionValues,
                                location: action.payload,
                            }
                        }
                    };     
                    case 'SET_SHOPFLOOR_PERIOD':
                        return {   
                            ...state,
                            shopfloor_filter_object: {
                                ...state.shopfloor_filter_object,
                                DimensionValues: {
                                    ...state.shopfloor_filter_object.DimensionKey,
                                    period: action.payload,
                                }
                            }
                        }; 
                        case 'SET_SHOPFLOOR_PERIOD_LIST':
                            return {   
                                ...state,
                                shopfloor_filter_object: {
                                    ...state.shopfloor_filter_object,
                                    DimensionValues: {
                                        ...state.shopfloor_filter_object.DimensionValues,
                                        period: action.payload,
                                    }
                                }
                            };                 
        default : return state
    }
}


export {UPDATE_SHOPFLOOR_DATA}